import feathersClient, {makeServicePlugin, BaseModel} from "@/feathers/feathers-client";
import {clearList, updateItems, addItems} from "@/vuex/feathers-vuex-plugins/custom-mutations";

class QueueDashboardAgents extends BaseModel {

  constructor(data, options) {
    super(data, options);
  }

  static modelName = 'QueueDashboardAgents';

}

const servicePath = 'queueDashAgents';
const servicePlugin = makeServicePlugin({
  enableEvents: false,
  idField: 'id',
  Model: QueueDashboardAgents,
  service: feathersClient.service(servicePath),
  servicePath,
  mutations: {
    updateItems(state, items) {
      updateItems(state, items)
    },
    updateItem(state, item){
      updateItems(state, [item])
    },
    clearList(state){
      clearList(state)
    },
    addItems(state, items){
      addItems(state, items)
    },
    addItem(state, item) {
      state = [...state, item];
    }
  }
});

export default servicePlugin;
